/**
 * filingYear.js
 * =============
 * Auto-calculates the correct Financial Year and Assessment Year
 * based on current date. No hardcoding needed.
 *
 * India tax filing rules:
 *   April onwards → filing for the FY that just ended
 *   Before April  → filing for the FY that ended the previous March
 *
 * Example:
 *   April 2026    → FY 2025-2026,  AY 2026-2027
 *   January 2026  → FY 2024-2025,  AY 2025-2026
 *   April 2027    → FY 2026-2027,  AY 2027-2028
 */

export function getCurrentFilingYear() {
  const now   = new Date();
  const month = now.getMonth() + 1; // 1 = January
  const year  = now.getFullYear();

  let fyStart, fyEnd;

  if (month >= 4) {
    // April to December — filing for FY that just ended March this year
    fyStart = year - 1;
    fyEnd   = year;
  } else {
    // January to March — filing for FY that ended March last year
    fyStart = year - 2;
    fyEnd   = year - 1;
  }

  return {
    financialYear:  `${fyStart}-${fyEnd}`,                          // "2025-2026"
    assessmentYear: `${fyEnd}-${fyEnd + 1}`,                        // "2026-2027"
    fyShort:        `${fyStart}-${String(fyEnd).slice(-2)}`,         // "2025-26"
    ayShort:        `${fyEnd}-${String(fyEnd + 1).slice(-2)}`,       // "2026-27"
    fyStart,
    fyEnd,
  };
}

/**
 * Returns a list of recent filing years for the dropdown
 * Always shows current + 2 previous years
 */
export function getRecentFilingYears() {
  const { fyStart, fyEnd } = getCurrentFilingYear();
  return [
    `${fyStart}-${fyEnd}`,
    `${fyStart - 1}-${fyEnd - 1}`,
    `${fyStart - 2}-${fyEnd - 2}`,
  ];
}
